import { components } from 'react-select';

export const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i className="tde-i tde-i-selectbox-arrow"></i>
        </components.DropdownIndicator>
      )
    );
  };
